import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { exists, generateHex } from '@nu-art/ts-common';
import { _className } from '@nu-art/thunderstorm-frontend/index';
const convert_NoteSection_Title = (section, highlight, leading) => {
    if (!section.title)
        return;
    const newLine = !!section.content?.length || !!section.subSections?.length;
    if (!highlight)
        return _jsxs("div", { className: 'smart-note-text__section__title', children: [section.title, newLine && _jsx("br", {})] });
    return _jsxs(_Fragment, { children: [_jsxs("div", { className: 'smart-note-text__section__title', children: [leading, _jsx("span", { children: section.title })] }), newLine && _jsx("br", {})] });
};
const convert_NoteSection_Content = (section, aiMode) => {
    const content = aiMode ? (section.aiContent ?? section.content) : section.content;
    if (!content)
        return;
    const newLine = !!section.subSections?.length;
    return _jsxs("div", { className: 'smart-note-text__section__content', children: [content, newLine && _jsx("br", {})] });
};
const convert_NoteSection = (section, ignoreSelection, aiMode, options) => {
    const key = generateHex(5);
    if (!section.isSelected && !ignoreSelection)
        return;
    const highlight = !!options?.highlightDispositionSection && !!section.dispositionSection;
    const className = _className('smart-note-text__section', section.indent && 'indent', !section.isSelected && 'fade', highlight && 'highlight');
    return _jsxs("div", { className: className, children: [highlight && options?.highlightAccessory, convert_NoteSection_Title(section, highlight, options?.highlightLeading), convert_NoteSection_Content(section, aiMode), section.subSections.map(subSection => convert_NoteSection(subSection, ignoreSelection, aiMode, options)), _jsx("br", {})] }, key);
};
export const convert_SmartNote = (note, ignoreSelection, options) => {
    return _jsxs("div", { className: 'smart-note-text', children: [exists(note.content) && _jsxs("div", { className: 'smart-note-text__content', children: [note.content, _jsx("br", {})] }), note.sections.map(section => convert_NoteSection(section, ignoreSelection, true, options))] });
};
//# sourceMappingURL=utils.js.map